"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assert() {
    return true;
}
exports.assert = assert;
